import { type SearchParams } from '@direct-frontend/modules-router';
import { OperatorType, stringifyFilterItems } from '@adv-frontend/filters';
import { FILTERS_OPEN } from '#shared/lib/constants';

export const getCharacteristicValueFilterSearchParams = (slug: string, value: string): SearchParams => {
    return {
        filter: stringifyFilterItems([
            {
                id: '0',
                filterId: slug,
                operator: OperatorType.Eq,
                value,
                wasAutoFocused: false,
            },
        ]),
        [FILTERS_OPEN]: 'true',
    };
};
